var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{staticClass:"o-autobuyer-input",class:_vm.validityClass,attrs:{"type":_vm.inputType},domProps:{"value":_vm.displayValue},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"input":_vm.handleInput}})}
var staticRenderFns = []

export { render, staticRenderFns }